<span>
     <span *ngIf="hideButton === false"
           class="pr-2">
          <button type="button"
                  [class]="buttonClass"
                  (click)="buttonClick(params)"
                  [name]="buttonName"
                  [title]="buttonTitle"
                  [id]="buttonName"
          >
               {{ buttonText }}
               <i *ngIf="buttonIcon !== ''"
                  [class]="buttonIcon" ></i>
          </button>
     </span>
     <label class="hide-button-text"
            *ngIf="hideButton === true"> {{hideButtonText}} </label>

     <span *ngIf="hideButton2 === false">
          <button type="button"
                  [class]="button2Class"
                  (click)="button2Click(params)"
                  [name]="button2Name"
                  [id]="button2Name"
                  [title]="button2Title"
          >
               {{ button2Text }}
               <i *ngIf="button2Icon !== ''"
                  [class]="button2Icon"></i>
          </button>
     </span>
     <label class="hide-button-text"
            *ngIf="hideButton2 === true"> {{hideButton2Text}} </label>
</span>

<style scoped>
     .hide-button-text {
          font-style: italic;
          color: #555555;
     }
</style>